export const buildOptions = (options = []) =>
    options.map((option) => ({
        label: option.label || '',
        value: option.id || '',
    }));

export const questionMapper = (question) => {
    let formattedQuestion = {};
    if (question) {
        const {
            id,
            currentAnswer,
            metaData: {
                question: title,
                questionType: type,
                questionDesc: helperText,
                validationMsg: errorMessage,
            },
        } = question;
        formattedQuestion = {
            [id]: {
                type: type || 'radio',
                asHeading: true,
                title,
                helperText,
                errorMessage,
                required: true,
                options: buildOptions(question.answers),
                value: currentAnswer,
            },
        };
    }
    return formattedQuestion;
};

export const buildFormSchema = (
    title,
    description,
    properties = [],
) => ({
    title,
    description,
    properties: {
        ...questionMapper(properties),
    },
});
